/**
 * 契約者（申込者）情報
 */
export class ContractorInfo {
	// public 変数	-----------------------------------------------------------
	private m_Name: string = null; // 契約者名
	private m_RomanName: string = null  // 契約者名（ローマ字）
	private m_DateOfBirth: string = null // 生年月日
	private m_Gender: string = null; // 性別
	private m_Address: string = null; // 住所
	private m_Tel: string = null; // 電話番号
	private m_MailAddress: string = null; // メールアドレス
	private m_LastName: string = null; // 契約者名（姓）
	private m_FirstName: string = null; // 契約者名（名）
	private m_RomanLastName: string = null; // 契約者名（姓・ローマ字）
	private m_RomanFirstName: string = null; // 契約者名（名・ローマ字）
	private m_PostalCode: string = null; // 郵便番号
	private m_Prefecture: string = null; // 都道府県
	private m_Address1: string = null; // 住所1
	private m_Address2: string = null; // 住所2
	private m_Year: string = null; // 年
	private m_Month: string = null; // 月
	private m_Date: string = null; // 日
	// ------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 契約者名 */
	public get name(): string { return this.m_Name; } public set name(name: string) { this.m_Name = name; }
	/** 契約者名（ローマ字） */
	public get romanName(): string { return this.m_RomanName; } public set romanName(romanName: string) { this.m_RomanName = romanName; }
	/** 生年月日 */
	public get dateOfBirth(): string { return this.m_DateOfBirth; } public set dateOfBirth(dateOfBirth: string) { this.m_DateOfBirth = dateOfBirth; }
	/** 性別 */
	public get gender(): string { return this.m_Gender; } public set gender(gender: string) { this.m_Gender = gender; }
	/** 住所 */
	public get address(): string { return this.m_Address; } public set address(address: string) { this.m_Address = address; }
	/** 電話番号 */
	public get tel(): string { return this.m_Tel; } public set tel(tel: string) { this.m_Tel = tel; }
	/** メールアドレス */
	public get mailAddress(): string { return this.m_MailAddress; } public set mailAddress(mailAddress: string) { this.m_MailAddress = mailAddress; }
	/** 契約者名（姓） */
	public get lastName(): string { return this.m_LastName; } public set lastName(lastName: string) { this.m_LastName = lastName; }
	/** 契約者名（名） */
	public get firstName(): string { return this.m_FirstName; } public set firstName(firstName: string) { this.m_FirstName = firstName; }
	/** 契約者名（姓・ローマ字） */
	public get romanLastName(): string { return this.m_RomanLastName; } public set romanLastName(romanLastName: string) { this.m_RomanLastName = romanLastName; }
	/** 契約者名（名・ローマ字） */
	public get romanFirstName(): string { return this.m_RomanFirstName; } public set romanFirstName(romanFirstName: string) { this.m_RomanFirstName = romanFirstName; }
	/** 郵便番号 */
	public get postalCode(): string { return this.m_PostalCode; } public set postalCode(postalCode: string) { this.m_PostalCode = postalCode; }
	/** 都道府県 */
	public get prefecture(): string { return this.m_Prefecture; } public set prefecture(prefecture: string) { this.m_Prefecture = prefecture; }
	/** 住所1 */
	public get address1(): string { return this.m_Address1; } public set address1(address1: string) { this.m_Address1 = address1; }
	/** 住所2 */
	public get address2(): string { return this.m_Address2; } public set address2(address2: string) { this.m_Address2 = address2; }
	/** 年 */
	public get year(): string { return this.m_Year; } public set year(year: string) { this.m_Year = year; }
	/** 月 */
	public get month(): string { return this.m_Month; } public set month(month: string) { this.m_Month = month; }
	/** 日 */
	public get date(): string { return this.m_Date; } public set date(date: string) { this.m_Date = date; }

	// --------------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ------------------------------------------------------------------------
}
